<template>
  <div>
    <!-- 基本情報 -->
    <TabPanel>
      <!-- 経費項目 -->
      <app-input-status
        label="経費項目"
        color="green"
        :message="expenseTypeIdError"
        :validationError="expenseTypeIdError ? true : false"
        :success="expenseTypeId && !expenseTypeIdError ? true : false"
      />
      <AppSentBackItem
        color="green"
        :message="getSentBackItemMessage('expense_type_id')"
      />
      <app-pull-down-list
        color="green"
        placeholder="経費目的を選択してください"
        :items="expenseTypes"
        v-model="expenseTypeId"
        name="expenseTypeId"
        :showIcon="false"
      />
      <!-- 支出額 -->

      <app-input-status
        label="支出額"
        color="green"
        :message="expenseAmountError"
        :validationError="expenseAmountError ? true : false"
        :success="expenseAmount && !expenseAmountError ? true : false"
      />
      <AppSentBackItem
        color="green"
        :message="getSentBackItemMessage('expense_amount')"
      />
      <div class="flex items-center">
        <app-text-input
          class="mr-2 w-40 text-right"
          type="number"
          :block="false"
          color="green"
          rows="1"
          placeholder="0"
          v-model.number="expenseAmount"
          name="expenseAmount"
        >
        </app-text-input>
        <app-checkbox
          :fieldId="String(prorateType.id)"
          color="green"
          :explanation="'按分する'"
          :rounded="true"
          v-model="isDistributed"
        />
        <!-- 按分する場合 -->
        <!-- v-show="ref.prorate.selected.length === 1" -->

        <div class="ml-3 flex items-center" v-if="isDistributed">
          <span class="w-16">
            <app-text-input
              type="number"
              v-model.number="numerator"
              name="numerator"
              color="green"
              class="text-center"
              style="padding: 1px"
            />
            <!-- @change="onChangeProrate()" -->
          </span>
          <span class="ml-3 text-green">/</span>
          <span class="w-16 ml-3">
            <app-text-input
              type="number"
              v-model.number="denominator"
              name="denominator"
              color="green"
              class="text-center"
              style="padding: 1px"
            />
            <!-- @change="onChangeProrate()" -->
          </span>
          <span class="ml-3 text-green">
            {{ calcPercent(numerator, denominator) }}%
          </span>
          <span class="ml-3 text-green font-bold">=</span>
          <span class="ml-3 text-green font-bold">
            {{ prorateAmount(expenseAmount, numerator, denominator) }}
          </span>
          <span class="ml-1 text-green font-bold">円</span>
        </div>
      </div>
      <!-- </div> -->

      <!-- 支出年月日 -->
      <app-input-status
        label="支出年月日"
        color="green"
        :message="expenseDateError"
        :validationError="expenseDateError ? true : false"
        :success="expenseDate && !expenseDateError ? true : false"
      />
      <AppSentBackItem
        color="green"
        :message="getSentBackItemMessage('expense_date')"
      />
      <app-date-input
        placeholder="年/月/日"
        color="green"
        v-model="expenseDate"
        name="expenseDate"
      >
      </app-date-input>
      <!-- 支出内容 -->
      <div class="flex mt-5">
        <app-input-status
          label="支出内容"
          color="green"
          :message="expenseContent1Error"
          :validationError="expenseContent1Error ? true : false"
          :success="expenseContent1 && !expenseContent1Error ? true : false"
        />
        <span class="ml-3 text-lg text-green" style="height: 28px;">
          | 1行目に入力してください
        </span>
      </div>
      <AppSentBackItem
        color="green"
        :message="getSentBackItemMessage('expense_content1')"
      />
      <!-- テキストエリア ２行入力でき、１行目は必須項目 -->

      <div
        class="border w-full h-auto flex flex-col px-2 py-2"
        style="border-radius: 20px;"
      >
        <textarea
          placeholder="支出内容を入力してください"
          color="green"
          rows="1"
          maxlength="100"
          class="w-full mb-2 focus:outline-none resize-none"
          style="height:48px; background: rgba(0, 0, 0, 0);"
          v-model="expenseContent1"
          name="expenseContent1"
        />
        <div style="border: 1px dashed #549A1D;" />
        <textarea
          placeholder="補記が必要な場合に入力してください"
          color="green"
          rows="1"
          maxlength="100"
          class="w-full mt-2 focus:outline-none resize-none"
          style="height:24px; background: rgba(0, 0, 0, 0);"
          v-model="expenseContent2"
          name="expenseContent2"
        />
      </div>
      <div class="mt-7">
        <AppSentBackItem
          color="green"
          :message="getSentBackItemMessage('expense_content2')"
        />
      </div>
    </TabPanel>
    <!-- 領収書添付 -->
    <TabPanel class="mr-5">
      <app-input-status label="領収書" color="green" />
      <AppSentBackItem
        color="green"
        :message="getSentBackItemMessage('files')"
      />
      <AppImageUploader @changed="handleImages" type="receipt" color="green" />
    </TabPanel>
    <TabPanel class="mr-5">
      <AppOfficeMessage></AppOfficeMessage>
    </TabPanel>
  </div>
</template>
<script>
import { reactive, onMounted } from 'vue'
import { TabPanel } from '@headlessui/vue'
import AppInputStatus from '@/components/ui/AppInputStatus.vue'
import AppPullDownList from '@/components/ui/AppPullDownList.vue'
import AppTextInput from '@/components/ui/AppTextInput.vue'
import AppDateInput from '@/components/ui/AppDateInput.vue'
import AppCheckbox from '@/components/ui/AppCheckbox.vue'
import AppImageUploader from '@/components/ui/AppImageUploader.vue'
import AppSentBackItem from '@/components/ui/AppSentBackItem'
import AppOfficeMessage from '@/components/ui/AppOfficeMessage'
import { useReceiptForm } from '@/services/receipt/useReceiptForm'
import { useImgUploader } from '@/services/useImgUploader'
import { useReceipts } from '@/services/receipt/useReceipts'

export default {
  name: 'ReceiptForm',

  components: {
    TabPanel,
    AppInputStatus,
    AppPullDownList,
    AppTextInput,
    AppDateInput,
    AppCheckbox,
    AppImageUploader,
    AppSentBackItem,
    AppOfficeMessage,
  },

  setup() {
    const { imgUploader } = useImgUploader()
    const { currentReceipt } = useReceipts()
    const ref = reactive({
      prorate: {
        selected: [],
      },
    })

    const prorateType = { id: 0, largeName: '按分する' }

    /**
     * 按分計算し、カンマ区切りをつけた文字列を返す
     *
     * @param {number} amount 支出額
     * @param {number} numerator 分子
     * @param {number} denominator 分母
     * @return {string}
     */
    const prorateAmount = (amount, numerator, denominator) => {
      if (
        typeof numerator !== 'number' ||
        typeof denominator !== 'number' ||
        numerator === 0 ||
        denominator === 0
      ) {
        // invalid
        return ''
      }

      return Math.floor((numerator * amount) / denominator ).toLocaleString()
    }

    /**
     * パーセントを計算する
     *
     * @param {number} numerator 分子
     * @param {number} denominator 分母
     * @return {string}
     */
    const calcPercent = (numerator, denominator) => {
      if (
        typeof numerator !== 'number' ||
        typeof denominator !== 'number' ||
        numerator === 0 ||
        denominator === 0
      ) {
        // invalid
        return ''
      }

      const percent = Math.floor((numerator / denominator) * 10000) / 100
      return percent.toString()
    }

    onMounted(() => {
      let images = []
      if (currentReceipt.images) {
        currentReceipt.files = currentReceipt.images
      }
      if (
        currentReceipt.files.length == 1 &&
        currentReceipt.files[0].normalImage == null
      ) {
        images = []
      } else {
        for (let i = 0; i < currentReceipt.files.length; i++) {
          currentReceipt.files[i].blackImage != null
            ? images.push(currentReceipt.files[i].blackImage)
            : images.push(currentReceipt.files[i].normalImage)
        }
      }
      imgUploader.error = ''
      imgUploader.files = []
      imgUploader.dropped = 0
      imgUploader.imgs = images
    })
    return {
      ref,
      prorateType,
      prorateAmount,
      calcPercent,
      ...useReceiptForm(),
    }
  },
}
</script>
<style lang="scss"></style>
